import { Check, ChevronRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { OperationalImage } from "@/components/OperationalPlaceholder";
import { Breadcrumbs, FinalCta, PageHero } from "@/components/Shared";
import { servicePages } from "@/data/site";

function ItemList({ items = [] }) {
  return <div className="service-item-list">{items.map((item) => <span key={item}><Check aria-hidden="true"/>{item}</span>)}</div>;
}

function ResponsibilityLedger({ rows }) {
  return <div className="responsibility-ledger">{rows.map(([owner, responsibility], index) => <article key={owner}><span>{String(index + 1).padStart(2, "0")}</span><div><h3>{owner}</h3><p>{responsibility}</p></div></article>)}</div>;
}

function CoordinationDiagram({ nodes }) {
  return <ol className="coordination-diagram" aria-label="4PL coordination model">{nodes.map((node, index) => <li key={node}><span>{String(index + 1).padStart(2, "0")}</span><strong>{node}</strong>{index < nodes.length - 1 && <ChevronRight aria-hidden="true"/>}</li>)}</ol>;
}

function EditorialSection({ section, index }) {
  return <section className={`service-editorial ${index % 2 ? "service-editorial-tint" : ""}`}>
    <div className="service-editorial-heading"><span className="technical-label">{section.label}</span><h2>{section.title}</h2>{section.copy && <p>{section.copy}</p>}</div>
    {section.items && <ItemList items={section.items}/>}
    {section.ledger && <ResponsibilityLedger rows={section.ledger}/>}
    {section.diagram && <CoordinationDiagram nodes={section.diagram}/>}
  </section>;
}

export default function ServicePage({ type, openChat }) {
  const page = servicePages[type];
  return <>
    <Seo title={page.title} description={page.description} path={page.path} faq={page.concerns}/>
    <Breadcrumbs items={[["Home", "/"], [page.eyebrow]]}/>
    <PageHero {...page} service={type} openChat={openChat} scene={<OperationalImage src={page.image} alt={page.imageAlt} caption={page.imageCaption} eager/>}/>
    {page.sections.map((section, index) => <EditorialSection key={section.label} section={section} index={index}/>) }
    <FinalCta openChat={openChat} service={type} title={page.primary} copy={page.finalCopy}/>
  </>;
}
